import React from 'react';
import { ExpandableSection } from 'src/modules/shared/components/molecules/expandable-section';
import { useI18n } from 'src/modules/shared/hooks/provider-bounded/i18n';

/**
 * Shared collapsible activity section used by integration-related timelines.
 */
interface ActivitySectionProps {
  /** Content rendered inside the section body. */
  children: React.ReactNode;
  /** Whether the section should show a loading state. */
  loading?: boolean;
  /** Optional title override. Defaults to the shared activity label. */
  title?: string;
  /** Whether the section starts expanded on first render. */
  isInitiallyExpanded?: boolean;
  /** Optional class names applied to the outer container. */
  className?: string;
  /** Optional class names applied to the expandable content area. */
  contentClassName?: string;
}

export const ActivitySection: React.FC<ActivitySectionProps> = ({
  children,
  loading = false,
  title,
  isInitiallyExpanded = false,
  className = 'rounded-xl border border-slate-200 bg-white',
  contentClassName = 'max-h-56',
}) => {
  const { t } = useI18n();

  return (
    <div className={className}>
      <ExpandableSection
        title={title ?? t('shared.activitySection.title')}
        loading={loading}
        isInitiallyExpanded={isInitiallyExpanded}
        expansionControl="left-icon"
        contentClassName={contentClassName}
        titleClassName="!text-sm text-slate-700"
      >
        {children}
      </ExpandableSection>
    </div>
  );
};
